import { Chunk, HashSet, pipe, Schema, SchemaGetter } from 'effect';

import type { TaxonFilterStateSet } from '../state/taxon';
import {
  TaxonFilterStateSet as TaxonFilterStateSetSchema,
  TaxonCode as TaxonCodeSchema,
} from '../state/taxon';

const taxonFilterStateSetToUrlArray = (taxonSet: TaxonFilterStateSet): string[] =>
  pipe(taxonSet, Chunk.fromIterable, Chunk.toArray);

const urlArrayToTaxonFilterStateSet = (taxonArray: readonly string[]): TaxonFilterStateSet =>
  pipe(
    taxonArray,
    Chunk.fromIterable,
    Chunk.filter((s) => s.length > 0),
    Chunk.map((s) => TaxonCodeSchema.make(s)),
    HashSet.fromIterable
  );

export const TaxonSerializable = Schema.String.pipe(
  Schema.decodeTo(Schema.toType(TaxonFilterStateSetSchema), {
    decode: SchemaGetter.transform((str) =>
      urlArrayToTaxonFilterStateSet(str.split(',').filter((s) => s.length > 0))
    ),
    encode: SchemaGetter.transform((taxonSet) => taxonFilterStateSetToUrlArray(taxonSet).join(',')),
  })
);

export const TaxonUrlQuery = Schema.Struct({
  taxon: Schema.optional(Schema.Array(Schema.String)),
});

export const TaxonToUrl = Schema.toType(TaxonFilterStateSetSchema).pipe(
  Schema.decodeTo(TaxonUrlQuery, {
    decode: SchemaGetter.transform((taxonSet) => {
      const taxonArray = taxonFilterStateSetToUrlArray(taxonSet);
      return taxonArray.length > 0 ? { taxon: taxonArray } : {};
    }),
    encode: SchemaGetter.transform((urlData) => urlArrayToTaxonFilterStateSet(urlData.taxon ?? [])),
  })
);
